import axiosInstance from "auth/FetchInterceptor";
import {
  VOUCHER_API,
  VOUCHER_SEARCH_GRID,
  VOUCHER_EXPORT_EXCEL,
  VOUCHER_USAGE_SEARCH_GRID,
  VOUCHER_DETAIL_API,
  VOUCHER_OVERVIEW_STATS,
  VOUCHER_DAILY_TREND_CHART,
  VOUCHER_ROI_CHART,
  VOUCHER_LEADERBOARD,
} from "constants/ApiConstant";
const VoucherService = {};

VoucherService.voucherSearchGrid = function (data) {
  return axiosInstance.post(VOUCHER_SEARCH_GRID, data);
};

VoucherService.getDetailVoucher = function (id) {
  const url = `${VOUCHER_DETAIL_API}/${id}`;
  return axiosInstance.get(url, null);
};

VoucherService.getVoucherById = function (id) {
  return axiosInstance.get(`${VOUCHER_API}/${id}`, null);
};

VoucherService.addVoucher = function (data) {
  return axiosInstance.post(VOUCHER_API, data);
};

VoucherService.updateVoucher = function (data) {
  return axiosInstance.put(VOUCHER_API, data);
};

VoucherService.delVoucher = function (id) {
  return axiosInstance.delete(`${VOUCHER_API}/${id}`, null);
};

VoucherService.getVoucherUsageApi = function (data) {
  return axiosInstance.post(VOUCHER_USAGE_SEARCH_GRID, data);
};

VoucherService.voucherExportExcelApi = function (data) {
  return axiosInstance.post(VOUCHER_EXPORT_EXCEL, data, {
    headers: {
      "Content-Type": "application/json",
    },
    responseType: "blob",
  });
};

VoucherService.getVoucherOverviewStats = function (data) {
  return axiosInstance.get(VOUCHER_OVERVIEW_STATS, data);
};

VoucherService.getVoucherDailyTrendChart = function (data) {
  return axiosInstance.post(VOUCHER_DAILY_TREND_CHART, data);
};

VoucherService.getVoucherRoiChart = function (data) {
  return axiosInstance.post(VOUCHER_ROI_CHART, data);
};

VoucherService.getVoucherLeaderboard = function (data) {
  return axiosInstance.post(VOUCHER_LEADERBOARD, data);
};

export default VoucherService;
